import type { IconId } from './index';

/**
 * The emoji the game used before it drew its own icons, and the icon that replaced each.
 * Only for converting old saves (feed posts and memes). Written as escapes so the source
 * itself has no emoji in it. Longest first, so sequences win over their parts.
 */
const LEGACY: ReadonlyArray<readonly [string, IconId]> = [
  ['\u{1F415}\u{200D}\u{1F9BA}', 'dog'],
  ['\u{1F635}\u{200D}\u{1F4AB}', 'dizzy'],
  ['\u{1F408}\u{200D}\u{2B1B}', 'black-cat'],
  ['\u{1F1FA}\u{1F1F8}', 'us-flag'],
  ['\u{1F3CD}\u{FE0F}', 'three-wheeler'],
  ['\u{1F6E5}\u{FE0F}', 'yacht'],
  ['\u{1F574}\u{FE0F}', 'revenuer'],
  ['\u{1F5E3}\u{FE0F}', 'shout'],
  ['\u{1F3DA}\u{FE0F}', 'shack'],
  ['\u{1F6CB}\u{FE0F}', 'couch'],
  ['\u{1F6CF}\u{FE0F}', 'bed'],
  ['\u{1F578}\u{FE0F}', 'dream-catcher'],
  ['\u{1F56F}\u{FE0F}', 'candle'],
  ['\u{1F570}\u{FE0F}', 'grandfather-clock'],
  ['\u{1F5D1}\u{FE0F}', 'trash-can'],
  ['\u{1F6CD}\u{FE0F}', 'grocery-bag'],
  ['\u{1F6E2}\u{FE0F}', 'smoker'],
  ['\u{1F5BC}\u{FE0F}', 'picture'],
  ['\u{1F3F7}\u{FE0F}', 'price-tag'],
  ['\u{1F321}\u{FE0F}', 'thermometer'],
  ['\u{1F576}\u{FE0F}', 'shades'],
  ['\u{1F39F}\u{FE0F}', 'scratcher'],
  ['\u{1F3D5}\u{FE0F}', 'camp'],
  ['\u{1F3DD}\u{FE0F}', 'island'],
  ['\u{1F32A}\u{FE0F}', 'tornado'],
  ['\u{1F37A}', 'beer'],
  ['\u{1F32D}', 'hotdog'],
  ['\u{1F37B}', 'cheers'],
  ['\u{1F96B}', 'empty-can'],
  ['\u{1F943}', 'moonshine'],
  ['\u{1FAD9}', 'jar'],
  ['\u{1F377}', 'strawberry-hill'],
  ['\u{1F353}', 'strawberry'],
  ['\u{1F964}', 'mtn-dewd'],
  ['\u{1F953}', 'pork-rinds'],
  ['\u{1F363}', 'sushi'],
  ['\u{1F371}', 'tv-dinner'],
  ['\u{1F355}', 'pizza'],
  ['\u{1F357}', 'fried-chicken'],
  ['\u{1F356}', 'ribs'],
  ['\u{1F958}', 'casserole'],
  ['\u{1F33D}', 'corn'],
  ['\u{1F369}', 'donut'],
  ['\u{1F36C}', 'butterscotch'],
  ['\u{1F36B}', 'candy-bar'],
  ['\u{1F95C}', 'peanuts'],
  ['\u{1F952}', 'pickle'],
  ['\u{1F9CA}', 'ice'],
  ['\u{1F6AC}', 'smokes'],
  ['\u{1F415}', 'dog'],
  ['\u{1F436}', 'dog'],
  ['\u{1F40A}', 'gator'],
  ['\u{1F41F}', 'catfish'],
  ['\u{1F420}', 'goldfish'],
  ['\u{1F400}', 'rat'],
  ['\u{1F99D}', 'raccoon'],
  ['\u{1F404}', 'cow'],
  ['\u{1F402}', 'bull'],
  ['\u{1F414}', 'chicken'],
  ['\u{1F429}', 'poodle'],
  ['\u{1F408}', 'black-cat'],
  ['\u{1F43A}', 'wolf'],
  ['\u{1F98C}', 'deer'],
  ['\u{1F422}', 'turtle'],
  ['\u{1F406}', 'leopard'],
  ['\u{1F985}', 'eagle'],
  ['\u{1F98D}', 'inflatable-gorilla'],
  ['\u{1F9A9}', 'flamingo'],
  ['\u{1FABF}', 'porch-goose'],
  ['\u{1F697}', 'car'],
  ['\u{1F6FB}', 'lifted-truck'],
  ['\u{1F69B}', 'semi'],
  ['\u{1F69A}', 'box-truck'],
  ['\u{1F49C}', 'donk'],
  ['\u{1F699}', 'el-camino'],
  ['\u{1F693}', 'police-car'],
  ['\u{1F694}', 'police-car'],
  ['\u{1F69C}', 'riding-mower'],
  ['\u{1F6F5}', 'rascal'],
  ['\u{1F691}', 'ambulance'],
  ['\u{1F6B2}', 'bike'],
  ['\u{1F680}', 'rocket'],
  ['\u{1F6F8}', 'ufo'],
  ['\u{1F4EF}', 'air-horn'],
  ['\u{1F3C1}', 'checkered-flag'],
  ['\u{1F6A8}', 'siren'],
  ['\u{1F7EB}', 'mud-splat'],
  ['\u{1F6DE}', 'tire-planter'],
  ['\u{1F642}', 'smile'],
  ['\u{1F610}', 'meh'],
  ['\u{1F644}', 'eyeroll'],
  ['\u{1F635}', 'knocked-out'],
  ['\u{1F62D}', 'crying'],
  ['\u{1F624}', 'huffing'],
  ['\u{1F975}', 'overheated'],
  ['\u{1F60D}', 'heart-eyes'],
  ['\u{1F970}', 'smitten'],
  ['\u{1F634}', 'sleepy'],
  ['\u{1F922}', 'queasy'],
  ['\u{1F920}', 'cowboy'],
  ['\u{1F915}', 'hurt'],
  ['\u{1F47D}', 'alien'],
  ['\u{1F47B}', 'ghost'],
  ['\u{1F480}', 'skull'],
  ['\u{1F9D4}', 'man'],
  ['\u{1F469}', 'woman'],
  ['\u{1F474}', 'old-man'],
  ['\u{1F476}', 'baby'],
  ['\u{1F464}', 'person'],
  ['\u{1F64B}', 'raise-hand'],
  ['\u{1F938}', 'cartwheel'],
  ['\u{1F3C3}', 'runner'],
  ['\u{1F93C}', 'wrestlers'],
  ['\u{1F9D9}', 'gnome'],
  ['\u{1F487}', 'haircut'],
  ['\u{1F441}', 'eye'],
  ['\u{1F440}', 'eyes'],
  ['\u{1F4AA}', 'flex'],
  ['\u{1F64F}', 'pray'],
  ['\u{1F91C}', 'fist-bump'],
  ['\u{1F91D}', 'handshake'],
  ['\u{1F44D}', 'thumbs-up'],
  ['\u{1F919}', 'shaka'],
  ['\u{1F446}', 'point-up'],
  ['\u{1F485}', 'nails'],
  ['\u{1F48B}', 'lips'],
  ['\u{1F9B7}', 'dentures'],
  ['\u{1FAC1}', 'lungs'],
  ['\u{270D}\u{FE0F}', 'writing'],
  ['\u{1F6AA}', 'door'],
  ['\u{1F3E0}', 'trailer'],
  ['\u{1F3E1}', 'double-wide'],
  ['\u{1F4BA}', 'recliner'],
  ['\u{1FA91}', 'chair'],
  ['\u{1F6BD}', 'toilet'],
  ['\u{1F6C1}', 'clawfoot-tub'],
  ['\u{1F4FA}', 'tv'],
  ['\u{1F4FB}', 'ham-radio'],
  ['\u{1F3A4}', 'microphone'],
  ['\u{1F3AE}', 'gamepad'],
  ['\u{1FAE7}', 'lava-lamp'],
  ['\u{1F4A1}', 'bulb'],
  ['\u{1F9FA}', 'laundry'],
  ['\u{1F9FD}', 'sponge'],
  ['\u{1F9F4}', 'oil-bottle'],
  ['\u{1F6D2}', 'cart'],
  ['\u{1F381}', 'gift'],
  ['\u{1F4E6}', 'box'],
  ['\u{1F9F6}', 'yarn'],
  ['\u{2702}\u{FE0F}', 'scissors'],
  ['\u{1FA93}', 'axe'],
  ['\u{1F528}', 'hammer'],
  ['\u{1F527}', 'wrench'],
  ['\u{1F529}', 'scrap'],
  ['\u{2699}\u{FE0F}', 'gear'],
  ['\u{1F50C}', 'copper-wire'],
  ['\u{1F50B}', 'battery'],
  ['\u{1FAAB}', 'battery-low'],
  ['\u{1F526}', 'flashlight'],
  ['\u{1F506}', 'headlamp'],
  ['\u{1F4E1}', 'satellite-dish'],
  ['\u{1F6DF}', 'kiddie-pool'],
  ['\u{1F3CA}', 'above-ground-pool'],
  ['\u{1F384}', 'xmas-lights'],
  ['\u{1FAA7}', 'yard-sign'],
  ['\u{1FA72}', 'clothesline'],
  ['\u{1F4F1}', 'phone'],
  ['\u{260E}\u{FE0F}', 'telephone'],
  ['\u{1F4DE}', 'telephone'],
  ['\u{1F4F8}', 'camera'],
  ['\u{1F4F9}', 'video-camera'],
  ['\u{1F4CB}', 'clipboard'],
  ['\u{1F4DC}', 'scroll'],
  ['\u{1F4F0}', 'newspaper'],
  ['\u{1F4C8}', 'chart-up'],
  ['\u{1F4CA}', 'bar-chart'],
  ['\u{1F4C5}', 'calendar'],
  ['\u{1F4CD}', 'pin'],
  ['\u{1F4CC}', 'pushpin'],
  ['\u{1F4EC}', 'mailbox'],
  ['\u{2709}\u{FE0F}', 'envelope'],
  ['\u{1F9FE}', 'receipt'],
  ['\u{1F4B3}', 'credit-card'],
  ['\u{1F4BC}', 'briefcase'],
  ['\u{1F512}', 'lock'],
  ['\u{1F50D}', 'magnifier'],
  ['\u{1F52D}', 'scope'],
  ['\u{1F52E}', 'crystal-ball'],
  ['\u{1F4BE}', 'save'],
  ['\u{2328}\u{FE0F}', 'keyboard'],
  ['\u{1F50A}', 'speaker'],
  ['\u{1F4F6}', 'signal'],
  ['\u{1F4E4}', 'share'],
  ['\u{1F310}', 'globe'],
  ['\u{1F30E}', 'globe'],
  ['\u{1F9EC}', 'dna'],
  ['\u{2696}\u{FE0F}', 'balance'],
  ['\u{1FAB5}', 'plank'],
  ['\u{1FA95}', 'banjo'],
  ['\u{1F455}', 'tshirt'],
  ['\u{1F456}', 'jeans'],
  ['\u{1F9E6}', 'sock'],
  ['\u{1F97E}', 'boot'],
  ['\u{1F45F}', 'croc'],
  ['\u{1F9E2}', 'cap'],
  ['\u{1F453}', 'glasses'],
  ['\u{1F451}', 'crown'],
  ['\u{1F48D}', 'ring'],
  ['\u{1F48E}', 'gem'],
  ['\u{1F5FC}', 'tower'],
  ['\u{1F3A8}', 'paint'],
  ['\u{1F4B5}', 'cash'],
  ['\u{1F4B8}', 'money-wings'],
  ['\u{1F4B0}', 'moneybag'],
  ['\u{1FA99}', 'coin'],
  ['\u{1F4B2}', 'dollar'],
  ['\u{1F3E7}', 'atm'],
  ['\u{1F3B0}', 'slots'],
  ['\u{1F3B1}', 'eight-ball'],
  ['\u{1F3B2}', 'dice'],
  ['\u{1F0CF}', 'cards'],
  ['\u{1F3AF}', 'target'],
  ['\u{1F3C6}', 'trophy'],
  ['\u{1F3C5}', 'medal'],
  ['\u{1F386}', 'fireworks'],
  ['\u{1F389}', 'party'],
  ['\u{1F3A1}', 'fortune-wheel'],
  ['\u{1F3E5}', 'hospital'],
  ['\u{1F38E}', 'dolls'],
  ['\u{1F490}', 'flowers'],
  ['\u{1F339}', 'rose'],
  ['\u{1F3B5}', 'notes'],
  ['\u{2764}\u{FE0F}', 'heart'],
  ['\u{1F525}', 'fire'],
  ['\u{1F495}', 'hearts'],
  ['\u{1F496}', 'hearts'],
  ['\u{1F498}', 'heart-arrow'],
  ['\u{2600}\u{FE0F}', 'sun'],
  ['\u{1F319}', 'moon'],
  ['\u{1F315}', 'full-moon'],
  ['\u{1F30A}', 'wave'],
  ['\u{1F4A7}', 'drop'],
  ['\u{1F4A6}', 'sweat'],
  ['\u{1F4A8}', 'dash'],
  ['\u{1F331}', 'sprout'],
  ['\u{1F33F}', 'herb'],
  ['\u{1F332}', 'pine'],
  ['\u{1F338}', 'blossom'],
  ['\u{1F4A4}', 'zzz'],
  ['\u{1F4A5}', 'boom'],
  ['\u{1F4AC}', 'speech'],
  ['\u{1F6AB}', 'no'],
  ['\u{26A0}\u{FE0F}', 'warning'],
  ['\u{1F4AF}', 'hundred'],
  ['\u{1F534}', 'red-button'],
  ['\u{1F7E2}', 'pip-on'],
  ['\u{25B6}\u{FE0F}', 'play'],
  ['\u{2B06}\u{FE0F}', 'arrow-up'],
  ['\u{21A9}\u{FE0F}', 'back'],
  ['\u{1F501}', 'repeat'],
  ['\u{1F3CD}', 'three-wheeler'],
  ['\u{1F6E5}', 'yacht'],
  ['\u{1F574}', 'revenuer'],
  ['\u{1F5E3}', 'shout'],
  ['\u{1F3DA}', 'shack'],
  ['\u{1F6CB}', 'couch'],
  ['\u{1F6CF}', 'bed'],
  ['\u{1F578}', 'dream-catcher'],
  ['\u{1F56F}', 'candle'],
  ['\u{1F570}', 'grandfather-clock'],
  ['\u{1F5D1}', 'trash-can'],
  ['\u{1F6CD}', 'grocery-bag'],
  ['\u{1F6E2}', 'smoker'],
  ['\u{1F5BC}', 'picture'],
  ['\u{1F3F7}', 'price-tag'],
  ['\u{1F321}', 'thermometer'],
  ['\u{1F576}', 'shades'],
  ['\u{1F39F}', 'scratcher'],
  ['\u{1F3D5}', 'camp'],
  ['\u{1F3DD}', 'island'],
  ['\u{1F32A}', 'tornado'],
  ['\u{26FD}', 'gas-pump'],
  ['\u{270B}', 'high-five'],
  ['\u{23F0}', 'alarm-clock'],
  ['\u{23F1}', 'stopwatch'],
  ['\u{231A}', 'pocket-watch'],
  ['\u{2660}', 'suit-spade'],
  ['\u{2665}', 'suit-heart'],
  ['\u{2666}', 'suit-diamond'],
  ['\u{2663}', 'suit-club'],
  ['\u{2728}', 'sparkles'],
  ['\u{2B50}', 'star'],
  ['\u{26A1}', 'bolt'],
  ['\u{2705}', 'check'],
  ['\u{274C}', 'cross'],
  ['\u{2B1C}', 'empty'],
  ['\u{2753}', 'question'],
  ['\u{26AA}', 'pip-off'],
  ['\u{25B6}', 'play'],
  ['\u{2B07}', 'arrow-down'],
  ['\u{2B05}', 'arrow-left'],
  ['\u{27A1}', 'arrow-right'],
  ['\u{2934}', 'hop'],
  ['\u{270D}', 'writing'],
  ['\u{2702}', 'scissors'],
  ['\u{2699}', 'gear'],
  ['\u{260E}', 'telephone'],
  ['\u{2709}', 'envelope'],
  ['\u{2328}', 'keyboard'],
  ['\u{2696}', 'balance'],
  ['\u{2764}', 'heart'],
  ['\u{2600}', 'sun'],
  ['\u{26A0}', 'warning'],
  ['\u{2B06}', 'arrow-up'],
  ['\u{21A9}', 'back'],
];

const lookup = new Map<string, IconId>(LEGACY);
const pattern = new RegExp(LEGACY.map(([e]) => e).join('|'), 'gu');

/** Old text with its emoji turned into :icon: tokens. */
export const fromEmoji = (text: string): string =>
  text.replace(pattern, (e) => `:${lookup.get(e) ?? 'question'}:`);
